module.exports = __webpack_public_path__ + "static/media/Trash_Can_Icon_Gray.5247a70f.svg";